/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import { Document, Share, SharesTitle } from 'types';
import PartnerSharesTableRow from './PartnerSharesTableRow';

type PartnerSharesTableBodyProps = {
  currentPage: number;
  fetchPartnerData: () => void;
  isCoOwner?: boolean;
  partnerId: string;
  rowsPerPage: number;
  shares: Share[];
  sharesTitles: SharesTitle[];
  showEncumbranceColumn: boolean;
  showSharesTitleColumn: boolean;
  hasMainSharesTitleDisabled: boolean;
  societySharesTitleDocument?: Document;
  societySharesTitleDocumentWithCoOwners?: Document;
};

const PartnerSharesTableBody: FC<PartnerSharesTableBodyProps> = ({
  currentPage,
  fetchPartnerData,
  isCoOwner = false,
  partnerId,
  rowsPerPage,
  shares,
  sharesTitles,
  showEncumbranceColumn,
  showSharesTitleColumn,
  hasMainSharesTitleDisabled,
  societySharesTitleDocument,
  societySharesTitleDocumentWithCoOwners,
}: PartnerSharesTableBodyProps) => {
  const firstItemIndex = (currentPage - 1) * rowsPerPage + 1;

  return (
    <tbody>
      {shares?.map((share: Share, index: number) => (
        <PartnerSharesTableRow
          fetchPartnerData={fetchPartnerData}
          index={index + firstItemIndex}
          isCoOwner={isCoOwner}
          key={`share-${index}`}
          partnerId={partnerId}
          share={share}
          sharesTitles={sharesTitles}
          showEncumbranceColumn={showEncumbranceColumn}
          showSharesTitleColumn={showSharesTitleColumn}
          hasMainSharesTitleDisabled={hasMainSharesTitleDisabled}
          societySharesTitleDocument={societySharesTitleDocument}
          societySharesTitleDocumentWithCoOwners={
            societySharesTitleDocumentWithCoOwners
          }
        />
      ))}
    </tbody>
  );
};

export default PartnerSharesTableBody;
